import { z } from "zod";

export const SUPPORTED_CURRENCIES = ["USD", "EUR", "GBP", "KES", "NGN", "ZAR", "INR", "JPY", "CAD", "AUD"] as const;
export const ETF_CATEGORIES = ["equity", "fixed_income", "commodity", "real_estate", "multi_asset"] as const;
export const DIVIDEND_FREQUENCIES = ["monthly", "quarterly", "semi_annual", "annual"] as const;

export const etfFormSchema = z.object({
  ticker_symbol: z
    .string()
    .min(1, "Ticker symbol is required")
    .max(10, "Ticker symbol must be 10 characters or fewer")
    .regex(/^[A-Z0-9]+$/, "Ticker symbol must be uppercase alphanumeric"),
  etf_name: z
    .string()
    .min(1, "ETF name is required")
    .max(200, "ETF name must be 200 characters or fewer"),
  category: z.enum(ETF_CATEGORIES, { required_error: "Category is required" }),
  units_held: z
    .number({ required_error: "Units held is required" })
    .positive("Units held must be greater than zero"),
  average_cost_per_unit: z
    .number({ required_error: "Average cost is required" })
    .positive("Average cost must be greater than zero"),
  currency: z.enum(SUPPORTED_CURRENCIES, { required_error: "Currency is required" }),
  purchase_date: z.string().min(1, "Purchase date is required"),
  dividend_per_unit: z
    .number()
    .nonnegative("Dividend per unit must be non-negative")
    .optional(),
  dividend_frequency: z.enum(DIVIDEND_FREQUENCIES).optional(),
  notes: z.string().optional(),
});

export type ETFFormValues = z.infer<typeof etfFormSchema>;
